import React from 'react';

import { Box } from '@/shared/ui/layout/Box';

import AIContent from '@/features/ai-chat/components/AskGXDrawer/Messages/AIMessage/AIContent/AIContent';
import MessageFooter from '@/features/ai-chat/components/AskGXDrawer/Messages/MessageFooter/MessageFooter';
import { useRateAnswer } from '@/features/ai-chat/components/AskGXDrawer/Messages/RateAnswer/useRateAnswer';
import SymbolsPreviewSection from '@/features/ai-chat/components/AskGXDrawer/Messages/SymbolsPreviewSection/SymbolsPreviewSection';
import type { AIMessage as AIMessageType } from '@/features/ai-chat/types/chat.types';
import Typography from '@/shared/ui/typography/Text';

const AIMessage = ({
  msg,
  isSending,
  isLastMessage,
  prompt,
  version
}: {
  msg: AIMessageType;
  isSending: boolean;
  isLastMessage: boolean;
  prompt: string;
  version: number;
}) => {
  const { handleRate, conversationId } = useRateAnswer();

  return (
    <Box
      sx={{
        padding: 0,
        maxWidth: '100%',
        marginBottom: '12px',
        minWidth: '100%'
      }}
    >
      <Typography
        component='div'
        sx={{ overflowWrap: 'break-word', hyphens: 'auto', fontSize: '14px' }}
      >
        <AIContent msg={msg} />
      </Typography>
      <SymbolsPreviewSection
        isVisible={!isSending || !isLastMessage}
        msg={msg}
      />
      <MessageFooter
        conversationId={conversationId}
        isLastMessage={isLastMessage}
        isSending={isSending}
        msg={msg}
        prompt={prompt}
        version={version}
        onRate={handleRate}
      />
    </Box>
  );
};

export default AIMessage;
